<div class="container mx-auto px-4 py-8">
  <h1 class="text-2xl font-bold mb-8 text-center"> {{'CUSTOMER_FAQS' | translate}}</h1>

  <div class="grid grid-cols-1 md:grid-cols-3 gap-8">
    <!-- FAQ 1 -->
    <div class="bg-white p-6 rounded shadow">
      <h2 class="text-lg font-semibold mb-4"> {{'WHATIS_BRING_IT_NOW' | translate}}</h2>
      <p class="text-gray-700">
        {{'WHATIS_BRING_IT_NOW_ANSWER' | translate}}
      </p>
    </div>

    <!-- FAQ 2 -->
    <div class="bg-white p-6 rounded shadow">
      <h2 class="text-lg font-semibold mb-4"> {{'WHO_ARE_BRING_IT_NOW_DRIVERS' | translate}}</h2>
      <p class="text-gray-700">
        {{'WHO_ARE_BRING_IT_NOW_DRIVERS_ANSWER' | translate}}
      </p>
    </div>

    <!-- FAQ 3 -->
    <div class="bg-white p-6 rounded shadow">
      <h2 class="text-lg font-semibold mb-4"> {{'HOW_MUCH_DOES_IT_COST' | translate}}</h2>
      <p class="text-gray-700">
        {{'HOW_MUCH_DOES_IT_COST_ANSWER' | translate}}
      </p>
    </div>

    <!-- FAQ 4 -->
    <div class="bg-white p-6 rounded shadow">
      <h2 class="text-lg font-semibold mb-4"> {{'WILL_DRIVER_HELP_WITH_PACKING' | translate}}</h2>
      <p class="text-gray-700">
        {{'WILL_DRIVER_HELP_WITH_PACKING_ANSWER' | translate}}
      </p>
    </div>

    <!-- FAQ 5 -->
    <div class="bg-white p-6 rounded shadow">
      <h2 class="text-lg font-semibold mb-4"> {{'ARE_THERE_ANY_ITEMS_THAT_ARE_PROHIBITED' | translate}}</h2>
      <p class="text-gray-700">
        {{'ARE_THERE_ANY_ITEMS_THAT_ARE_PROHIBITED_ANSWER' | translate}}
      </p>
    </div>

    <!-- FAQ 6 -->
    <div class="bg-white p-6 rounded shadow">
      <h2 class="text-lg font-semibold mb-4"> {{'HOW_DO_I_PAY' | translate}}</h2>
      <p class="text-gray-700">
        {{'HOW_DO_I_PAY_ANSWER' | translate}}
      </p>
    </div>
  </div>
</div>
